import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appDateFormat]',
  standalone: true
})
export class DateFormatDirective {

  constructor(private el: ElementRef, private control: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/\D/g, ''); // Supprimer tous les caractères non numériques
    
    // Limiter à 8 chiffres maximum (JJMMAAAA)
    if (value.length > 8) {
      value = value.slice(0, 8);
    }
    
    // Appliquer le formatage automatique
    const formattedValue = this.formatDate(value);
    
    // Mettre à jour la valeur de l'input
    input.value = formattedValue;
    
    // Mettre à jour le FormControl
    if (this.control && this.control.control) {
      this.control.control.setValue(formattedValue, { emitEvent: false });
    }
  }

  @HostListener('blur', ['$event'])
  onBlur(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    
    // Validation finale au moment de quitter le champ
    if (value && !this.isValidDate(value)) {
      // Ajouter une classe d'erreur ou déclencher une validation
      input.classList.add('invalid-date');
    } else {
      input.classList.remove('invalid-date');
    }
  }

  private formatDate(value: string): string {
    if (value.length === 0) return '';
    
    let formatted = '';
    
    // Format progressif pendant la saisie
    if (value.length <= 2) {
      // Jour (JJ)
      formatted = value;
    } else if (value.length <= 4) {
      // Jour-Mois (JJ-MM)
      formatted = value.slice(0, 2) + '-' + value.slice(2);
    } else if (value.length <= 8) {
      // Jour-Mois-Année (JJ-MM-AAAA)
      formatted = value.slice(0, 2) + '-' + value.slice(2, 4) + '-' + value.slice(4);
    }
    
    return formatted;
  }

  private isValidDate(dateString: string): boolean {
    // Vérifier le format JJ-MM-AAAA
    const dateRegex = /^(\d{2})-(\d{2})-(\d{4})$/;
    const match = dateString.match(dateRegex);
    
    if (!match) {
      return false;
    }
    
    const day = parseInt(match[1], 10);
    const month = parseInt(match[2], 10);
    const year = parseInt(match[3], 10);
    
    // Vérifications de base
    if (month < 1 || month > 12) {
      return false;
    }
    
    if (day < 1 || day > 31) {
      return false;
    }
    
    // Vérifications plus précises selon le mois
    const daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    
    // Année bissextile
    if (month === 2 && this.isLeapYear(year)) {
      daysInMonth[1] = 29;
    }
    
    if (day > daysInMonth[month - 1]) {
      return false;
    }
    
    // Vérifier que l'année est raisonnable (entre 1900 et 2100)
    if (year < 1900 || year > 2100) {
      return false;
    }
    
    return true;
  }

  private isLeapYear(year: number): boolean {
    return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
  }
}